import React, { useState, useEffect } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { Button, DatePicker } from "antd";
import { TfiReload } from "react-icons/tfi";
const { RangePicker } = DatePicker;

const HistoryOrders = () => {
  const [search, setSearch] = useState("");
  const disableFutureDates = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.toDate() > today;
  };
  return (
    <>
      <div className="cat_list_header">
        <div className="cat_search_box">
          <TextField
            id="custom-input"
            placeholder="search"
            variant="outlined"
            autocomplete="off"
            size="small"
            className="input_container"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              style: {
                // backgroundColor: "#ffe6e6",
                // border: "1px solid red",
              },
            }}
            FormHelperTextProps={{
              style: {
                marginTop: "0vh",
              },
            }}
          />
        </div>
        <div className="cat_lis_ad_rs">
          <RangePicker disabledDate={disableFutureDates} />
          <div className="input_box_container">
            <TextField
              id="custom-select"
              select
              variant="outlined"
              defaultValue="option1"
              size="small"
              className="input_container"
              //   onChange={(e) => setdeliverycommission(e.target.value)}
              //   value={deliverycommission}
            ></TextField>
          </div>
          <Button icon={<TfiReload />} iconPosition="start">
            Refresh
          </Button>
        </div>
      </div>
    </>
  );
};

export default HistoryOrders;
